import script from "./adminTable.vue?vue&type=script&setup=true&lang=js"
export * from "./adminTable.vue?vue&type=script&setup=true&lang=js"

import "./adminTable.vue?vue&type=style&index=0&id=f94a9a84&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f94a9a84"]])

export default __exports__